import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './SearchAutoCorrectContainer';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';

type Props = PropsFromRedux;
type State = {
  selectedKeywords: Array<string>;
  recommendedKeywords: Array<string>;
};

export class RawSearchAutoCorrect extends React.Component<Props, State> {
  onForceSearchCorrectedClicked = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    const { onCorrectQuery, autoCorrectedQuery } = this.props;
    doctrineAnalytics('Search ZeroResultCorrectedQueryClicked');

    if (!event.metaKey && !event.ctrlKey && event.nativeEvent.which !== 2) {
      event.preventDefault();
      onCorrectQuery(autoCorrectedQuery);
    }
  };

  onForceSearchTypoClicked = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    const { onForceTypo } = this.props;

    doctrineAnalytics('Search ZeroResultQueryClicked');

    if (!event.metaKey && !event.ctrlKey && event.nativeEvent.which !== 2) {
      event.preventDefault();
      onForceTypo();
    }
  };

  render() {
    const { correctedUrl, typoUrl, query, highlightedWords } = this.props;
    return (
      <div className="search-advice-autocorect">
        <span className="corrected-query">
          <span className="corrected-query__title">
            <FormattedMessage id="app.pages.search.autocorrect.title" />{' '}
          </span>
          <a
            href={correctedUrl}
            onClick={this.onForceSearchCorrectedClicked}
            className="search-advice-autocorect__link"
          >
            {highlightedWords.map((word: typeof highlightedWords[0]) => (
              <React.Fragment key={word.key}>
                {!word.same && (
                  <b className="corrected-query__word corrected-query__word--edited">
                    {word.text}
                  </b>
                )}
                {word.same && (
                  <span className="corrected-query__word">{word.text}</span>
                )}
              </React.Fragment>
            ))}
          </a>
        </span>
        <div className="original-query">
          <span className="original-query__title">
            <FormattedMessage id="app.pages.search.autocorrect.zeroResults" />{' '}
          </span>
          <a
            href={typoUrl}
            onClick={this.onForceSearchTypoClicked}
            className="search-advice-autocorect__link"
          >
            {query}
          </a>
        </div>
      </div>
    );
  }
}
export const SearchAutoCorrect = Connect(RawSearchAutoCorrect);
